export const OPEN = 'campusModal/OPEN';
export const UPDATE = 'campusModal/UPDATE';
export const CLOSE = 'campusModal/CLOSE';